import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="error-timeout"
export default class extends Controller {
  static values = {
    errors: Boolean
  }

  static targets = ["button", "error"]

  connect() {
    if (this.errorsValue) {
      this.buttonTargets.forEach(button => {
        button.disabled = true
      })

      this.errorTarget.textContent = "Please wait 10 seconds before trying again."
      this.errorTarget.classList.remove("hidden")

      setTimeout(() => {
        this.buttonTargets.forEach(button => {
          button.disabled = false
        })
        this.errorTarget.classList.add("hidden")
      }, 10000)
    }
  }
}
